
import { Link } from "react-router-dom";
import "./HomeLeadership.css";

const HomeLeadership = () => {
  return (
    <section className="rector-registrar-section">
      <h2 className="rector-registrar-title">
        University Administration
      </h2>

      <div className="rector-registrar-cards">
        <div className="rector-registrar-card">
          <div className="rector-registrar-image">
            <img
              src="/person/registrar-Vijay.JPG"
              alt="Prof. B. Vijaya Kumar Naidu"
            />
          </div>

          <h3 className="rector-registrar-name">
            Prof. B. Vijaya Kumar Naidu
          </h3>

          <p className="rector-registrar-role">
            Registrar
          </p>

          <p className="rector-registrar-university">
            Rayalaseema University
          </p>

          <Link
            to="/administration/registrar"
            className="rector-registrar-btn"
          >
            View Profile
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeLeadership;
